module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.project) ? _c('div', {
    staticClass: "screen-loading"
  }, [_vm._v("\n    Loading...\n  ")]) : _vm._e(), _vm._v(" "), (_vm.project) ? _c('div', {
    staticClass: "view project"
  }, [_c('div', {
    staticClass: "project-header",
    style: (_vm.header_css)
  }, [(_vm.client) ? _c('div', {
    staticClass: "pretitle"
  }, [_c('div', {
    staticClass: "textlink",
    on: {
      "click": function($event) {
        return _vm.goto('/client/' + _vm.client['.key'])
      }
    }
  }, [_vm._v(_vm._s(_vm.client.name))]), _vm._v("   —   \n        Opgave\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.project.name))])]), _vm._v(" "), _c('div', {
    staticClass: "filterbtns"
  }, [_c('filterbtn', {
    attrs: {
      "active": _vm.showing == 'home'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setShowing('home')
      }
    }
  }, [_vm._v("Overblik")]), _vm._v(" "), _c('filterbtn', {
    attrs: {
      "active": _vm.showing == 'comments'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setShowing('comments')
      }
    }
  }, [_vm._v(_vm._s(_vm.getCommentsCount('project', _vm.project['.key'])) + " kommentarer")]), _vm._v(" "), _c('filterbtn', {
    attrs: {
      "active": _vm.showing == 'spec'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setShowing('spec')
      }
    }
  }, [_vm._v("Specifikation")]), _vm._v(" "), (_vm.show_beta_content || _vm.is_user('wp')) ? _c('filterbtn', {
    attrs: {
      "active": _vm.showing == 'kanban'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setShowing('kanban')
      }
    }
  }, [_vm._v("Opgaver")]) : _vm._e(), _vm._v(" "), _c('filterbtn', {
    attrs: {
      "active": _vm.showing == 'timelogs'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setShowing('timelogs')
      }
    }
  }, [_vm._v("Tidstracking")]), _vm._v(" "), (_vm.economy_access) ? _c('filterbtn', {
    attrs: {
      "active": _vm.showing == 'economy'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setShowing('economy')
      }
    }
  }, [_vm._v("Økonomiposter")]) : _vm._e(), _vm._v(" "), (_vm.show_beta_content) ? _c('filterbtn', {
    attrs: {
      "active": _vm.showing == 'timeline'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setShowing('timeline')
      }
    }
  }, [_vm._v("Timeline")]) : _vm._e(), _vm._v(" "), _c('filterbtn', {
    attrs: {
      "active": _vm.showing == 'settings'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setShowing('settings')
      }
    }
  }, [_vm._v("Indstillinger")]), _vm._v(" "), _c('filterbtn', {
    attrs: {
      "active": _vm.showing == 'details'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setShowing('details')
      }
    }
  }, [_vm._v("Detaljer")])], 1), _vm._v(" "), (_vm.showing == 'home') ? [_c('masonry', [_c('div', {
    staticClass: "masonry-grid-item w1 h1"
  }, [_c('div', {
    staticClass: "snackbox"
  }, [_c('div', {
    staticClass: "t"
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "m"
  }, [_c('svgicon', {
    attrs: {
      "icon": "ionicons/ios-checkmark-outline"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "b"
  }, [_vm._v(_vm._s(_vm.getProjectDonePct(_vm.project)) + "%")])])]), _vm._v(" "), _c('div', {
    staticClass: "masonry-grid-item w2 h1"
  }, [_c('div', {
    staticClass: "snackbox"
  }, [_c('div', {
    staticClass: "m up"
  }, [_vm._v("\n              " + _vm._s(_vm._f("decimals")(_vm.project_budgetted_hours, 0)) + " timer\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "b"
  }, [_vm._v("Estimeret")])])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "masonry-grid-item w2 h1"
  }, [_c('div', {
    staticClass: "snackbox clickable",
    on: {
      "click": function($event) {
        return _vm.goto('/timelogs/any/any/' + _vm.project['.key'] + '/any/any')
      }
    }
  }, [_c('div', {
    staticClass: "t"
  }, [_vm._v("Tid booket")]), _vm._v(" "), _c('div', {
    staticClass: "m"
  }, [_c('svgicon', {
    attrs: {
      "icon": "ionicons/ios-calendar-outline"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "b"
  }, [_vm._v(_vm._s(_vm.hoursBooked) + " timer")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "masonry-grid-item w1 h1"
  }, [_c('div', {
    staticClass: "snackbox clickable",
    on: {
      "click": function($event) {
        return _vm.goto('/timelogs/any/any/' + _vm.project['.key'] + '/any/any')
      }
    }
  }, [_c('div', {
    staticClass: "t"
  }, [_vm._v("Tid tracket")]), _vm._v(" "), _c('div', {
    staticClass: "m"
  }, [_vm._v("\n\t\t\t\t      " + _vm._s(_vm._f("decimals")(_vm.project_budgetted_hours_spent_pct, 0)) + "%\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "b"
  }, [_vm._v(_vm._s(_vm._f("decimals")(_vm.project_timelogs_total_hours, 0)) + " timer")])])]), _vm._v(" "), _c('div', {
    staticClass: "masonry-grid-item w1 h1"
  }, [_c('div', {
    staticClass: "snackbox clickable",
    on: {
      "click": function($event) {
        return _vm.openTimeloggerBasic({
          project_key: _vm.project['.key']
        })
      }
    }
  }, [_c('div', {
    staticClass: "m up"
  }, [_c('svgicon', {
    attrs: {
      "icon": "ionicons/ios-play-outline"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "b"
  }, [_vm._v("Log arbejdstid")])])]), _vm._v(" "), (_vm.project.gitRepoUrl) ? _c('div', {
    staticClass: "masonry-grid-item w1 h1"
  }, [_c('div', {
    staticClass: "snackbox clickable",
    on: {
      "click": function($event) {
        return _vm.openURLNewWindow(_vm.project.gitRepoUrl)
      }
    }
  }, [_c('div', {
    staticClass: "m up"
  }, [_c('svgicon', {
    attrs: {
      "icon": "fontawesome/git"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "b"
  }, [_vm._v("Git repo")])])]) : _vm._e(), _vm._v(" "), (_vm.project.trelloUrl) ? _c('div', {
    staticClass: "masonry-grid-item w1 h1"
  }, [_c('div', {
    staticClass: "snackbox clickable",
    on: {
      "click": function($event) {
        return _vm.openURLNewWindow(_vm.project.trelloUrl)
      }
    }
  }, [_c('div', {
    staticClass: "m up"
  }, [_c('svgicon', {
    attrs: {
      "icon": "fontawesome/trello"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "b"
  }, [_vm._v("Trello board")])])]) : _vm._e(), _vm._v(" "), (_vm.project.timelineUrl) ? _c('div', {
    staticClass: "masonry-grid-item w1 h1"
  }, [_c('div', {
    staticClass: "snackbox clickable",
    on: {
      "click": function($event) {
        return _vm.openURLNewWindow(_vm.project.timelineUrl)
      }
    }
  }, [_c('div', {
    staticClass: "t up"
  }, [_vm._v("Tidsplan")]), _vm._v(" "), _c('div', {
    staticClass: "m d"
  }, [_c('svgicon', {
    attrs: {
      "icon": "ionicons/android-options"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "masonry-grid-item w2 h1"
  }, [_c('div', {
    staticClass: "snackbox clickable",
    on: {
      "click": function($event) {
        _vm.showing = 'spec'
      }
    }
  }, [_c('div', {
    staticClass: "m up"
  }, [_c('svgicon', {
    attrs: {
      "icon": "ionicons/ios-list-outline"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "b"
  }, [(!_vm.spec && !_vm.project.specsheetUrl) ? [_vm._v("\n                Opgavespecifikation mangler!\n              ")] : [_vm._v("\n                Opgavespecifikation/tilbud\n              ")]], 2)])]), _vm._v(" "), (_vm.economy_access) ? _c('div', {
    staticClass: "masonry-grid-item w2 h1"
  }, [_c('div', {
    staticClass: "snackbox"
  }, [_c('div', {
    staticClass: "m up"
  }, [_vm._v("\n\t\t\t\t      " + _vm._s(_vm._f("money")(_vm.project_budget)) + " kr.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "b"
  }, [_vm._v("Budget ex. moms")])])]) : _vm._e(), _vm._v(" "), (_vm.project.docsUrl && _vm.globals.user.admin) ? _c('div', {
    staticClass: "masonry-grid-item w2 h2"
  }, [_c('div', {
    staticClass: "snackbox clickable",
    on: {
      "click": function($event) {
        return _vm.openURLNewWindow(_vm.project.docsUrl)
      }
    }
  }, [_c('div', {
    staticClass: "m up"
  }, [_c('svgicon', {
    attrs: {
      "icon": "ionicons/android-folder-open"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "b"
  }, [_vm._v("Google Drive")])])]) : _vm._e(), _vm._v(" "), (_vm.economy_access) ? _c('div', {
    staticClass: "masonry-grid-item w2 h1"
  }, [_c('div', {
    staticClass: "snackbox"
  }, [_c('div', {
    staticClass: "m up"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.get_invoiced_dkk)) + " kr.")]), _vm._v(" "), _c('div', {
    staticClass: "b"
  }, [_vm._v("Faktureret")])])]) : _vm._e(), _vm._v(" "), (_vm.economy_access) ? _c('div', {
    staticClass: "masonry-grid-item w2 h1"
  }, [_c('div', {
    staticClass: "snackbox"
  }, [_c('div', {
    staticClass: "m up"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.get_invoiced_and_paid_dkk)) + " kr.")]), _vm._v(" "), _c('div', {
    staticClass: "b"
  }, [_vm._v("Betalt")])])]) : _vm._e(), _vm._v(" "), (_vm.economy_access && _vm.project.status == 'active') ? _c('div', {
    staticClass: "masonry-grid-item w2 h1"
  }, [_c('div', {
    staticClass: "snackbox"
  }, [_c('div', {
    staticClass: "m up"
  }, [_vm._v(_vm._s(_vm._f("money")((_vm.project_payable_amount - _vm.get_invoiced_and_paid_dkk))) + " kr.")]), _vm._v(" "), _c('div', {
    staticClass: "b"
  }, [_vm._v("Resterende betaling")])])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('btn', {
    attrs: {
      "color": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleTagAndSave('projects', _vm.project, _vm.$store.getters['users/my_initials'])
      }
    }
  }, [(_vm.item_has_tag(_vm.project, _vm.$store.getters['users/my_initials'])) ? [_vm._v("● Mine projekter")] : [_vm._v("○ Mine projekter")]], 2), _vm._v(" "), _c('btn', {
    attrs: {
      "color": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleTagAndSave('projects', _vm.project, 'fakturaklar')
      }
    }
  }, [(_vm.item_has_tag(_vm.project, 'fakturaklar')) ? [_vm._v("● Faktura-klar")] : [_vm._v("○ Faktura-klar")]], 2)], 1)] : _vm._e(), _vm._v(" "), (_vm.showing == 'timelogs') ? [_c('box', {
    attrs: {
      "label": _vm.project_timelogs_total_hours + ' timer tracket'
    }
  }, [(_vm.project_timelogs) ? _c('timelogs-list', {
    attrs: {
      "timelogs": _vm.project_timelogs
    }
  }) : _c('p', [_vm._v("Ingen tid tracket endnu...")])], 1)] : _vm._e(), _vm._v(" "), (_vm.showing == 'timeline') ? [_c('box', {
    attrs: {
      "label": "New calendar"
    }
  }, [_c('full-calendar', {
    attrs: {
      "config": _vm.calendarConfig
    }
  })], 1), _vm._v(" "), _c('timeline', {
    attrs: {
      "title": "Timeline",
      "days-back": "7",
      "days-ahead": "120",
      "entries": [{
        title: '2018-08-25 >> 2018-09-03',
        date_from: _vm.project.start_date,
        date_to: _vm.project.end_date,
        color: _vm.projectColor,
        fillpct: 75
      } ]
    }
  })] : _vm._e(), _vm._v(" "), (_vm.showing == 'settings') ? _c('box', {
    attrs: {
      "label": 'Indstillinger'
    }
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col m50"
  }, [_c('inputfield', {
    attrs: {
      "label": "Opgavens titel"
    }
  }, [_c('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.project.name
    },
    on: {
      "change": function($event) {
        return _vm.change('name', $event)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Kunde"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.client_key),
      expression: "project.client_key"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.project, "client_key", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.change('client_key', $event)
      }]
    }
  }, _vm._l((_vm.clients_not_archived), function(client, key, i) {
    return _c('option', {
      key: 'tf23' + i,
      domProps: {
        "value": client.key
      }
    }, [_vm._v(_vm._s(client.name))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "select-arrow"
  }, [_vm._v("▾")])]), _vm._v(" "), (_vm.economy_access) ? [_c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": 'Timepris (Kundens normale timepris: ' + (_vm.client.hour_rate || 'Udefineret') + ')'
    }
  }, [_c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.project.hour_rate
    },
    on: {
      "change": function($event) {
        return _vm.change('hour_rate', $event)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.economy_access) ? [_c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Fast pris ex. moms (Gammel, brug i stedet Opgavespecifikationen)"
    }
  }, [_c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.project.fixed_price
    },
    on: {
      "change": function($event) {
        return _vm.change('fixed_price', $event)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.economy_access) ? [_c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Estimerede timer (Gammel, brug i stedet Opgavespecifikationen)"
    }
  }, [_c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.project.estimated_hrs
    },
    on: {
      "change": function($event) {
        return _vm.change('estimated_hrs', $event)
      }
    }
  })])] : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Færdig %"
    }
  }, [_c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.project.done_pct
    },
    on: {
      "change": function($event) {
        return _vm.change('done_pct', $event)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('inputfield', [_c('label', [_vm._v("Noter")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.notes),
      expression: "project.notes"
    }],
    attrs: {
      "name": "",
      "id": "",
      "cols": "30",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.project.notes)
    },
    on: {
      "change": function($event) {
        return _vm.change('notes', $event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "notes", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')], 2), _vm._v(" "), _c('div', {
    staticClass: "col m50"
  }, [_c('inputfield', {
    attrs: {
      "label": "Farve"
    }
  }, [_c('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.project.color
    },
    on: {
      "change": function($event) {
        return _vm.change('color', $event)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Status"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.status),
      expression: "project.status"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.project, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.change('status', $event)
      }]
    }
  }, _vm._l((_vm.globals.projectStatuses), function(status, key, i) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(status.title))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "select-arrow"
  }, [_vm._v("▾")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Betalingsmodel"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.payment_model),
      expression: "project.payment_model"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.project, "payment_model", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.change('payment_model', $event)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "fixed_price"
    }
  }, [_vm._v("Fast pris")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "time_expense"
    }
  }, [_vm._v("Tidsafregnet")])]), _vm._v(" "), _c('div', {
    staticClass: "select-arrow"
  }, [_vm._v("▾")])]), _vm._v(" "), _c('br'), _vm._v(" "), (false) ? _c('tags-preview', {
    attrs: {
      "tags": _vm.project.tags,
      "itemtype": 'project',
      "itemkey": _vm.project.key
    }
  }) : _vm._e(), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Tags"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.tags),
      expression: "project.tags"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.project.tags)
    },
    on: {
      "change": function($event) {
        return _vm.change('tags', $event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "tags", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Startdato (dd-mm-ååååå)"
    }
  }, [_c('input', {
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": _vm.project.start_date
    },
    on: {
      "change": function($event) {
        return _vm.change('start_date', $event)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Afslutningsdato (dd-mm-ååååå)"
    }
  }, [_c('input', {
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": _vm.project.end_date
    },
    on: {
      "change": function($event) {
        return _vm.change('end_date', $event)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.economy_access) ? [_c('inputfield', {
    attrs: {
      "label": "Dokument mappe-link (Google Drive)"
    }
  }, [_c('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.project.docsUrl
    },
    on: {
      "change": function($event) {
        return _vm.change('docsUrl', $event)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Tidsplan dokument-link"
    }
  }, [_c('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.project.timelineUrl
    },
    on: {
      "change": function($event) {
        return _vm.change('timelineUrl', $event)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Trello board link"
    }
  }, [_c('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.project.trelloUrl
    },
    on: {
      "change": function($event) {
        return _vm.change('trelloUrl', $event)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Git repo link"
    }
  }, [_c('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.project.gitRepoUrl
    },
    on: {
      "change": function($event) {
        return _vm.change('gitRepoUrl', $event)
      }
    }
  })])] : _vm._e()], 2)]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.submitChanges()
      }
    }
  }, [_vm._v("Opdatér opgave")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "btn color-secondary",
    on: {
      "click": function($event) {
        return _vm.archiveProject()
      }
    }
  }, [_vm._v("Arkivér opgave")])], 1) : _vm._e(), _vm._v(" "), (_vm.showing == 'economy') ? _c('box', {
    attrs: {
      "label": 'Økonomi'
    }
  }, [(false) ? _c('p', [_vm._v("Budget: " + _vm._s(_vm.outputMoney(_vm.getProjectBudgetTotal(_vm.project), 'b')))]) : _vm._e(), _vm._v(" "), _c('economy-posts', {
    attrs: {
      "posts": _vm.economyposts.posts,
      "totals": _vm.economyposts.totals,
      "fields": "invoice_no,invoice_date,invoiced,paid,amount"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.createNewEconomypost()
      }
    }
  }, [_vm._v("Opret ny økonomipost")])], 1) : _vm._e(), _vm._v(" "), (_vm.showing == 'details') ? _c('box', {
    attrs: {
      "label": 'Andet'
    }
  }, [_c('table', {
    staticClass: "table-a"
  }, [_c('tr', [_c('td', [_vm._v("Betalingsmodel")]), _vm._v(" "), _c('td', [(_vm.project.payment_model == 'fixed_price') ? [_vm._v("Fast pris")] : _vm._e(), _vm._v(" "), (_vm.project.payment_model == 'time_expense') ? [_vm._v("Tidsafregnet")] : _vm._e(), _vm._v(" "), (!_vm.project.payment_model) ? [_vm._v("?")] : _vm._e()], 2)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Timepris")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm._f("money")(_vm.project_hour_rate, 2)) + " kr.\n            ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Estimerede timer")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.project_budgetted_hours || '-') + " timer")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Arbejdstimer logget")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.project_timelogs_total_hours) + " timer")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("- Heraf markeret fakturérbare")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.project_billable_hours) + " timer")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Budget")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")(_vm.project_budget)) + " kr.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _c('td', [_vm._v(" ")])]), _vm._v(" "), (_vm.economy_access) ? _c('tr', [_c('td', [_vm._v("Kundens betaling")]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm._f("money")(_vm.project_payable_amount, 2)) + " kr.")])])]) : _vm._e(), _vm._v(" "), (_vm.economy_access) ? _c('tr', [_c('td', [_vm._v("- Faktureret")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")(_vm.get_invoiced_dkk, 2)) + " kr.")])]) : _vm._e(), _vm._v(" "), (_vm.economy_access) ? _c('tr', [_c('td', [_vm._v("- Betalt")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")(_vm.get_invoiced_and_paid_dkk, 2)) + " kr.")])]) : _vm._e(), _vm._v(" "), (_vm.economy_access) ? _c('tr', [_c('td', [_vm._v("Resterende betaling")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")((_vm.project_payable_amount - _vm.get_invoiced_and_paid_dkk), 2)) + " kr.")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _c('td', [_vm._v(" ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Betaling ud fra fakturérbare timer")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")(_vm.project_billable_hours_amount, 2)) + " kr.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Timepris * tidsforbrug")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")(_vm.project_hour_rate * _vm.project_timelogs_total_hours, 2)) + " kr.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Tid tracket ift. budget tidsramme")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.project_budgetted_hours_spent_pct) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Realiseret timepris")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")((_vm.project_payable_amount / _vm.project_timelogs_total_hours), 2)) + " kr.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _c('td', [_vm._v(" ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Projekt oprettet")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("date")(_vm.project.created, 'DD/MM-YYYY HH:MM')) + " ")])])])]) : _vm._e(), _vm._v(" "), (_vm.showing == 'spec') ? [(_vm.spec) ? _c('specsheet', {
    attrs: {
      "localspec": _vm.spec
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.spec) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.createSpec()
      }
    }
  }, [_vm._v("Opret opgavespecifikation")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.showing == 'comments') ? _c('box', {
    attrs: {
      "label": 'Kommentarer'
    }
  }, [_c('comments', {
    attrs: {
      "keytype": 'project',
      "keyis": _vm.project_key
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showing == 'kanban') ? _c('div', [_c('kanban')], 1) : _vm._e(), _vm._v(" "), (_vm.showing == '_tasks') ? _c('div', {
    attrs: {
      "id": "tasklists"
    }
  }, [_vm._l((_vm.projectTasklists), function(tasklist, i) {
    return (!tasklist.archived) ? _c('div', {
      staticClass: "tasklist"
    }, [_c('div', {
      staticClass: "tasklist-header"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(tasklist.name))]), _vm._v(" "), _c('div', {
      staticClass: "edit-btn",
      on: {
        "click": function($event) {
          return _vm.openTasklistPopup(tasklist)
        }
      }
    }, [_c('svgicon', {
      attrs: {
        "icon": "ionicons/gear-b"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      directives: [{
        name: "dragula",
        rawName: "v-dragula",
        value: (_vm.project_tasks),
        expression: "project_tasks"
      }],
      staticClass: "tasks",
      attrs: {
        "bag": "first-bag"
      }
    }, _vm._l((_vm.project_tasks), function(task, i) {
      return (task.tasklist_key == tasklist['.key'] && !task.archived) ? _c('div', {
        key: task['.key'],
        staticClass: "task",
        on: {
          "click": function($event) {
            return _vm.openTaskPopup(task)
          }
        }
      }, [_vm._v("\n            " + _vm._s(task.title) + "\n          ")]) : _vm._e()
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "tasklist-footer"
    }, [_c('div', {
      staticClass: "add-task-btn",
      on: {
        "click": function($event) {
          return _vm.addTask(tasklist)
        }
      }
    }, [_c('svgicon', {
      attrs: {
        "icon": "linearicons/home"
      }
    }), _vm._v(" Ny task\n          ")], 1)])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "add-tasklist-btn",
    on: {
      "click": function($event) {
        return _vm.addTaskList()
      }
    }
  }, [_c('svgicon', {
    attrs: {
      "icon": "linearicons/home"
    }
  }), _vm._v(" Ny liste\n      ")], 1)], 2) : _vm._e(), _vm._v(" "), (_vm.show_debug_data_boxes) ? _c('box', {
    attrs: {
      "label": "project"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.project))])]) : _vm._e(), _vm._v(" "), (_vm.activeTasklistKey) ? _c('div', {
    attrs: {
      "id": "tasklist-overlay"
    }
  }, [_c('div', {
    staticClass: "dimmer",
    on: {
      "click": function($event) {
        return _vm.closeTasklistPopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal"
  }, [_c('inputfield', [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeTasklist.name),
      expression: "activeTasklist.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.activeTasklist.name)
    },
    on: {
      "change": function($event) {
        return _vm.updateActiveTasklist(['name'])
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activeTasklist, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.archiveTasklist()
      }
    }
  }, [_vm._v("Slet tasklist")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.activeTaskKey) ? _c('div', {
    attrs: {
      "id": "task-overlay"
    }
  }, [_c('div', {
    staticClass: "dimmer",
    on: {
      "click": function($event) {
        return _vm.closeTaskPopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal"
  }, [_c('inputfield', [_c('label', [_vm._v("Titel")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeTask.title),
      expression: "activeTask.title"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.activeTask.title)
    },
    on: {
      "change": function($event) {
        return _vm.updateActiveTask(['title'])
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activeTask, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('inputfield', [_c('label', [_vm._v("Text")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeTask.text),
      expression: "activeTask.text"
    }],
    domProps: {
      "value": (_vm.activeTask.text)
    },
    on: {
      "change": function($event) {
        return _vm.updateActiveTask(['text'])
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activeTask, "text", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('inputfield', [_c('label', [_vm._v("Timetal estimat")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeTask.hours_estimate),
      expression: "activeTask.hours_estimate"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "9999",
      "step": "0.25"
    },
    domProps: {
      "value": (_vm.activeTask.hours_estimate)
    },
    on: {
      "change": function($event) {
        return _vm.updateActiveTask(['hours_estimate'])
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activeTask, "hours_estimate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('inputfield', [_c('label', [_vm._v("Done?")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeTask.done),
      expression: "activeTask.done"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.activeTask.done,
      "checked": Array.isArray(_vm.activeTask.done) ? _vm._i(_vm.activeTask.done, null) > -1 : (_vm.activeTask.done)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.activeTask.done,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.activeTask, "done", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.activeTask, "done", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.activeTask, "done", $$c)
        }
      }, function($event) {
        return _vm.flipTaskDone(_vm.activeTask)
      }]
    }
  })]), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.archiveTask()
      }
    }
  }, [_vm._v("Slet opgave")])], 1)]) : _vm._e()], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cd164192","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Project.vue
// module id = 624
// module chunks = 1